"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _typeGuards = require("../../../libs/typeGuards");

var _StatusCircle = _interopRequireDefault(require("../../ui-components/StatusCircle"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _assets = _interopRequireDefault(require("../../../preact-components/assets"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var titles = {
  new: 'New event',
  draft: 'Draft',
  published: 'Published event'
};

var Title = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Title, _Component);

  var _super = _createSuper(Title);

  function Title(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Title);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "titleInputRef", null);
    _this.state = {
      titleInputVisible: false
    };
    return _this;
  }

  (0, _createClass2.default)(Title, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      document.addEventListener('mousedown', function (event) {
        return _this2.onClickOutsideOfTitle(event);
      });
      document.addEventListener('keypress', function (event) {
        return _this2.onPressEnterInTitle(event);
      });
    }
  }, {
    key: "onTitleClicked",
    value: function onTitleClicked() {
      var _this3 = this;

      this.setState({
        titleInputVisible: true
      }, function () {
        if (_this3.titleInputRef) {
          _this3.titleInputRef.focus();
        }
      });
    }
  }, {
    key: "onClickOutsideOfTitle",
    value: function onClickOutsideOfTitle(event) {
      if (this.titleInputRef && !this.titleInputRef.contains(event.target)) {
        this.titleInputRef.blur();
        this.setState({
          titleInputVisible: false
        });
      }
    }
  }, {
    key: "onPressEnterInTitle",
    value: function onPressEnterInTitle(event) {
      if (this.titleInputRef && event.keyCode === 13) {
        this.titleInputRef.blur();
        this.setState({
          titleInputVisible: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          title = _this$props.title,
          onTitleChanged = _this$props.onTitleChanged,
          error = _this$props.error,
          eventId = _this$props.eventId,
          status = _this$props.status,
          isEventPassed = _this$props.isEventPassed;
      var metadata = isEventPassed && status === 'published' ? 'Past' : titles[status !== null && status !== void 0 ? status : 'new'];
      var statusPublishedVariant = status === 'published' ? 'published' : 'draft';
      var statusPastVariant = isEventPassed && status === 'published' ? 'past' : statusPublishedVariant;
      var statusVariant = status !== 'new' ? statusPastVariant : false;

      if (this.state.titleInputVisible) {
        return (0, _preact.h)("div", null, (0, _preact.h)("input", {
          className: (0, _classnames.default)('event-creator__title', 'qa-title-input', 'form-control'),
          type: "text",
          value: title,
          required: true,
          onChange: function onChange(event) {
            if ((0, _typeGuards.hasValueInEventTarget)(event)) {
              onTitleChanged(event.target.value.trim());
            }
          },
          maxLength: 250,
          ref: function ref(titleInput) {
            _this4.titleInputRef = titleInput;
          }
        }));
      }

      return (0, _preact.h)("div", {
        className: "event-creator__title-container"
      }, (0, _preact.h)(_Tooltip.default, {
        trigger: (0, _preact.h)("h2", {
          className: (0, _classnames.default)('event-creator__title', 'qa-title-text', {
            'event-creator__title--empty': !title
          }),
          onClick: function onClick() {
            return _this4.onTitleClicked();
          }
        }, (0, _preact.h)("span", null, title || 'Untitled Event', (0, _preact.h)(_assets.default, {
          icon: "edit",
          width: 20,
          height: 20
        }))),
        tooltipMessage: error ? error : title ? 'Rename' : 'Add a title' //eslint-disable-line
        ,
        customClasses: error ? 'tooltip-show' : undefined,
        qaClasses: "qa-title-tooltip"
      }), status === 'published' ? (0, _preact.h)("a", {
        className: "event-creator__external-link",
        target: "_blank",
        rel: "noreferrer",
        href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('communityUrl'), "/events/").concat(eventId)),
        "data-track-type": "click",
        "data-element-name": "event page lint"
      }, (0, _preact.h)(_assets.default, {
        icon: "externalLink",
        height: 22,
        width: 22,
        color: "#9599A2"
      })) : null, (0, _preact.h)("div", {
        className: "event-creator__creation-status pull-left"
      }, (0, _preact.h)(_StatusCircle.default, {
        variant: statusVariant
      }), (0, _preact.h)("p", {
        className: "event-creator__creation-status-text"
      }, metadata)));
    }
  }]);
  return Title;
}(_preact.Component);

var _default = Title;
exports.default = _default;